export const ProductVisibilityEnum = [
    { id: 'hidden', name: 'Hidden' },
    { id: 'catalog', name: 'Catalog' },
    { id: 'search', name: 'Search' },
    { id: 'catalog_search', name: 'Catalog Search' },
];